/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationsService {

    /**
     * Connects a user to a notification group for the workspace ID. If we send
     * messages to this group, all connected users will get a notification.
     * @param portfolioId The ID of the portfolio to connect the user to.
     * @param connectionId The SignalR connection ID.
     * @returns any OK
     * @throws ApiError
     */
    public static connectToPortfolio(
        portfolioId: string,
        connectionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/connect/portfolio/{portfolioId}',
            path: {
                'portfolioId': portfolioId,
            },
            query: {
                'connectionId': connectionId,
            },
        });
    }

    /**
     * @param workspaceId
     * @returns any OK
     * @throws ApiError
     */
    public static testNotifications(
        workspaceId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/test/{workspaceId}',
            path: {
                'workspaceId': workspaceId,
            },
        });
    }

    /**
     * Connects a user to a notification group for the workspace ID. If we send
     * messages to this group, all connected users will get a notification.
     * @param workspaceId The ID of the workspace to connect the user to.
     * @param connectionId The SignalR connection ID.
     * @returns any OK
     * @throws ApiError
     */
    public static connectToWorkspace(
        workspaceId: string,
        connectionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/notifications/connect/{workspaceId}',
            path: {
                'workspaceId': workspaceId,
            },
            query: {
                'connectionId': connectionId,
            },
        });
    }

}
